import requests from "./httpService";

const QuotationServices = { 
  getAllQuotation: async () => {
    return requests.get("/quotation-request/all");
  }, 

  getQuotationById: async (id) => {
    return requests.get(`/quotation-request/${id}`); 
  },

  addQuotation: async (body) => {
    return requests.post("/quotation-request/add", body); 
  },
   
  updateQuotation: async (id, body) => {
    return requests.put(`/quotation-request/${id}`, body); 
  },
 
  updateQuotationStatus: async (id, body) => {
    return requests.put(`/quotation-request/status/${id}`, body); 
  },
 
  deleteQuotation: async (id, body) => {
    return requests.delete(`/quotation-request/${id}`, body);
  },  

};

export default QuotationServices; 
